/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Děkujeme za registraci k odběru našeho zpravodaje. Váš 10% slevový kupón je k dispozici ve vaší e-mailové schránce.`
};

const da_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Tak for din tilmelding til vores nyhedsbrev. Din 10 % rabatkode er sendt til din e-mail.`
};

const de_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Danke für Ihre Anmeldung zum Newsletter. Ihr 10%-Rabattgutschein befindet sich in Ihrem E-Mail-Postfach.`
};

const en_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Thank you for subscribing to our newsletter. Your 10% discount voucher is available in your inbox.`
};

const es_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Gracias por suscribirse a nuestro boletín. Su cupón de descuento del 10% está disponible en su bandeja de entrada.`
};

const fr_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Merci de vous être inscrit à notre newsletter. Votre bon de réduction de 10% est disponible dans votre boîte mail.`
};

const hu_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Köszönjük, hogy feliratkozott hírlevelünkre. 10%-os kedvezményes utalványát megtalálja e-mail fiókjában.`
};

const it_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Grazie per esserti iscritto alla nostra newsletter. Il tuo buono sconto del 10% è disponibile nella tua casella di posta.`
};

const nl_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Bedankt voor je inschrijving op onze nieuwsbrief. Je kortingsbon van 10% is beschikbaar in je mailbox.`
};

const pl_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Dziękujemy za zapisanie się do newslettera. Twój kupon rabatowy 10% jest dostępny w Twojej skrzynce pocztowej.`
};

const pt_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Obrigado por se inscrever na nossa newsletter. O seu cupão de desconto de 10% está disponível na sua caixa de correio eletrónico.`
};

const sv_newsletter_subscription_success_text = /** @type {(inputs: {}) => string} */ () => {
	return `Tack för att du prenumererat på vårt nyhetsbrev. Din rabattkupong på 10 % finns i din e-post.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_subscription_success_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_subscription_success_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_subscription_success_text", locale)
	if (locale === "cs") return cs_newsletter_subscription_success_text(inputs)
	if (locale === "da") return da_newsletter_subscription_success_text(inputs)
	if (locale === "de") return de_newsletter_subscription_success_text(inputs)
	if (locale === "en") return en_newsletter_subscription_success_text(inputs)
	if (locale === "es") return es_newsletter_subscription_success_text(inputs)
	if (locale === "fr") return fr_newsletter_subscription_success_text(inputs)
	if (locale === "hu") return hu_newsletter_subscription_success_text(inputs)
	if (locale === "it") return it_newsletter_subscription_success_text(inputs)
	if (locale === "nl") return nl_newsletter_subscription_success_text(inputs)
	if (locale === "pl") return pl_newsletter_subscription_success_text(inputs)
	if (locale === "pt") return pt_newsletter_subscription_success_text(inputs)
	return sv_newsletter_subscription_success_text(inputs)
};
export { newsletter_subscription_success_text as "newsletter.subscription.success.text" }